<!-- ? Android Devices -->
@if (isAndroid) {
<p class="text-sm text-gray-900 text-center">
  دانلود اپلیکیشن
  <span class="text-green-500"> بهخوان </span>
</p>

<div class="w-full flex flex-wrap mt-3">
  <div class="w-full">
    <button class="text-sm btn-green-outline rounded-lg p-2 w-full !outline-none" (click)="installPwa()">
      وب اپلیکیشن
    </button>
  </div>
  <div class="w-full mt-3 ">
    <a class="text-sm bg-green-500 text-white p-2 w-full rounded-lg flex justify-center"
      href="https://s3.ir-thr-at1.arvanstorage.com/top-readers-publishers/apks/latest-native-app.apk"
      download="behkhaan">
      اپلیکیشن اندروید
    </a>
  </div>
</div>
}
@else {
<p class="text-sm text-gray-900">
  وب اپلیکیشن
  <span class="text-green-500 text-sm font-medium"> بهخوان </span>
  را به صفحۀ اصلی موبایل خود اضافه کنید.
</p>

<div class="w-full flex mt-4 flex-wrap">
  <div class="w-full">
    <ul>
      <li class="text-sm my-2 text-gray-900">
        در نوار پایین دکمۀ
        <span class="text-gray-900 text-sm font-medium"> Share </span>
        را انتخاب کنید.
      </li>
      <li class="text-sm my-2 text-gray-900">
        در منوی باز شده گزینۀ
        <span class="text-gray-900 text-sm font-medium"> Add to home screen </span>
        را انتخاب کنید.
      </li>
      <li class="text-sm my-2 text-gray-900">
        در مرحلۀ بعد در قسمت بالا روی
        <span class="text-gray-900 text-sm font-medium"> Add </span>
        کلیک کنید.
      </li>
    </ul>
  </div>

  <div class="w-full mt-4">
    <button class="text-sm bg-green-500 text-white rounded-lg p-2 w-full" (click)="close()">
      متوجه شدم!
    </button>
  </div>
</div>
}